import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { usePageStore } from '@legacy/stores/PageStore/pageStore.zustand';

export const useIframeEvent = () => {
  const { pathname, search } = useLocation();
  const setCurrentPage = usePageStore((s) => s.setCurrentPage);
  const setLastVisitedPage = usePageStore((s) => s.setLastVisitedPage);

  useEffect(() => {
    const handleIframeEvent = (event: MessageEvent) => {
      const {
        data: { pageIdentifier, eventId, pageId, pageTitle },
      } = event;
      if (eventId === 'pageIdentifier' && setLastVisitedPage) {
        setCurrentPage({
          pageIdentifier,
          pageId,
          pageTitle,
        });
        setLastVisitedPage(pathname + search, pageIdentifier);
      }
    };

    window?.addEventListener('message', handleIframeEvent as EventListener);

    return () => {
      window?.removeEventListener(
        'message',
        handleIframeEvent as EventListener,
      );
    };
  }, [setLastVisitedPage, pathname, search]);
};
